import TrustBox from "../trustpilot/trustBoxComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";

export default function WhyChooseHiperSectionComponent() {
    return (
        <div className="usp-campaign-container">
            <h2 className="heading heading--medium">Derfor skal du vælge fibernet fra Hiper</h2>
            <div className="usp-content">
                <div className="image">
                    <img className={'trophies'} src={imageMap.home.mvfp_pokal} alt="Vinder Mest Værdi For Pengene 2020, 2021, 2022, 2023, 2024 og 2025."/>
                </div>
                <div className="text">
                    <p>
                        Med Hiper får du en hurtig og stabil internetforbindelse til én af markedets bedste priser.
                        Et Lynhurtigt internet med al den hastighed du skal bruge til at streame, game og arbejde på.
                    </p>
                    <p>
                        Vores vigtigste opgave er at give vores kunder den bedste internetoplevelse.
                        Fordi en god forbindelse handler for os om mere end hastighed og pris.
                        Det handler også om at sikre dig en stabil forbindelse, der lever op til hele familiens behov.
                    </p>
                    <p>
                        Hiper har vundet &ldquo;Mest værdi for pengene&rdquo; &ndash;
                        og for sjette år i træk giver vi alle vores kunder mest værdi for pengene
                        blandt alle internetudbydere i 2020, 2021, 2022, 2023, 2024 og 2025.
                    </p>
                </div>
            </div>
            <TrustBox templateId={"539ad0ffdec7e10e686debd7"} height={"350px"} />
        </div>
    )
}
